import * as Yup from "yup";
import { TFunction } from "i18next";

export const validation = (t: TFunction) =>
    Yup.object({
        message: Yup.string()
            .min(2, `${t("registration.minLength")}2`)
            .max(65535, `${t("registration.maxLength")}65535`)
            .required(t("registration.required")),
    });
